import { AUTH_LOGIN_PATH } from '@/utils/routes/authLoginPath'
import { AuthStorage } from '@/utils/storage/AuthStorage'
import { clearOktaTokens, oktaLogout } from '@/utils/okta/oktaAuth'

export class AuthUtils {
  static readonly logout = (link?: string): Promise<void> | void => {
    // 현재 세션이 Okta 로그인일 때만 Okta signOut. 아니면 기존 Knox 로그아웃(+ 잔존 Okta 토큰 정리).
    const isOktaSession = AuthStorage.authMode.get() === 'okta'
    sessionStorage.clear()

    if (isOktaSession) {
      // Okta 세션 종료 → postLogoutRedirectUri(/login) 로 이동. 로그인 화면은 버튼 방식이라 자동 재로그인 안 됨.
      // LOGISPRD-9057: signOut 의 성공(redirect)/실패를 호출부(인터셉터 멤버십 가드)가 관찰할 수 있도록 promise 전파.
      // LOGISPRD-9129: oktaLogout 이 stop-first → clearTokensBeforeRedirect 로 강화됨 — 시그니처(Promise<void>) 동일하므로
      //   return 전파 경로 불변(9057 가드 불변식 유지). sessionStorage.clear()(M1)/knox 분기 불변(회귀 보호).
      //   LLD anchor: docs/lld/auth/LLD-9129-okta-logout-cleanup.md "## 분기 / 상태 전이", "## 핵심 로직 (의사 코드)".
      return oktaLogout()
    }

    clearOktaTokens()
    // LOGISPRD-12506: 이전엔 PATHS['auth.login']('@/utils/routes/paths')을 썼다. paths.tsx는
    // ROUTES_WITH_ELEMENTS(어드민 페이지 53개 모듈 전체)를 런타임에 순회해 PATHS를 만들기 때문에,
    // 그 import만으로 이 파일을 끌어오는 어떤 소비자(예: 온콜 콘솔의 MainHeader)든 어드민 모듈
    // 그래프 전체를 정적으로 끌고 온다. 값은 동일(/auth/login)하되 무거운 그래프를 끌지 않는
    // authLoginPath.ts의 단일 출처 상수를 쓴다.
    window.location.href = link || AUTH_LOGIN_PATH
  }

  // auth0(관리자) — AUTH_CD 는 '<화주코드><등급>'. 등급 0 또는 MASTER 이면 true (1.0 동치 + MASTER).
  static readonly isAuth0 = (): boolean => {
    const user = AuthStorage.user.get()
    if (user.auth === 'MASTER') return true
    return (user.auth ?? '').replace(user.shipper_code ?? '', '') === '0'
  }
}
